<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {replace} from 'svelte-spa-router';
	import {
		API,
		cabecalhoPadraoRequisicao,
		dadosUsuarioLS,
		enviarDadosFormulario,
		esconderPartesCPF,
		StatusHttp, TextoFeedback,
		TipoEvento,
		verificarSessionStorage
	} from '../../utils';
	import TBox from '../templates/TBox.svelte';

	const dispatch = createEventDispatcher();

	let idProjeto; 
	let resumo = "";
	let observacoes = "";
	let linkApresentacao, linkVideo, dataHora, local, cursoEAD;
	let apresentadorTitular, apresentadorSubstituto;

	let informacosAPICache = null;
	let dadosUsuario;
	let dataInicialCadastro = "";
	let dataFinalCadastro = "";
	let meusProjetos = [];
	let apresentadores = [];
	let totalProjetos = 0;

	let totalCaracteresResumo = 0;
	let totalCaracteresObservacoes = 0;
	$: totalCaracteresResumo=resumo.length;
	$: totalCaracteresObservacoes=observacoes.length;

	onMount(async () => {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando dados ...',
		});
		
		dadosUsuario = dadosUsuarioLS();

		if (!verificarSessionStorage('AVAL_TOKEN'))
			replace("/painel");

		await carregarMeusProjetosAPI();

		informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));

		dataInicialCadastro = informacosAPICache.prazos?.cadastro_apresentacoes_projeto_inicio ?? '[#Erro - necessário limpar cache]';
		dataFinalCadastro = informacosAPICache.prazos?.cadastro_apresentacoes_projeto_fim ?? '[#Erro - necessário limpar cache]';

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		document.getElementById("seletorProjeto").addEventListener("change", () => {
			let projetoSelecionado = meusProjetos.find( projeto => projeto.id == idProjeto);
			let apresentadoresObjeto;

			if (projetoSelecionado != undefined) {
				if (projetoSelecionado?.preve_inclusao_alunos_ead == null || projetoSelecionado?.conhece_agenda2030 == null) {
					dispatch('routeEvent', {
						tipo: TipoEvento.ABRIR_MODAL,
						titulo: 'Aviso',
						conteudo: 'Projeto selecionado está com o cadastro incompleto! Favor atualizar seu projeto, adicionando as informações que faltam.'
					});

					return;
				}

				apresentadoresObjeto = projetoSelecionado.participantes.filter( participante => participante.papel == "BOLSISTA");

				// verifica se o filtro de apresentadores é vazio ou indefinido
				if (apresentadoresObjeto?.length == 0) {
					dispatch('routeEvent', {
						tipo: TipoEvento.ABRIR_MODAL,
						titulo: 'Erro',
						conteudo: 'Projeto selecionado não possui nenhum participante/bolsista vinculado!'
					});

					apresentadores  = [];
				} else {
					apresentadores  = [ ... apresentadoresObjeto ];
				}
			} else apresentadores  = [];
		})
	});

	async function submeterFormulario(event) {
		enviarDadosFormulario('POST', dispatch, replace, 'apresentacoes', 
			JSON.stringify({
				idUsuario: parseInt(dadosUsuario.id),
				idProjeto: idProjeto,
				resumo: resumo,
				observacoes:observacoes,
				linkApresentacao: linkApresentacao,
				linkVideo: linkVideo,
				dataHora: dataHora,
				local: local,
				apresentadorTitular: apresentadorTitular,
				apresentadorSubstituto: apresentadorSubstituto
			}), 
			'Inscrição da apresentação do projeto realizada com sucesso!', 
			'#/usuario/meus-projetos', 
			'#/painel');
	}

	const carregarMeusProjetosAPI = async () => {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando projetos ...',
		});

		const resposta = await fetch(API('usuarios/listagem/meus-projetos'), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("/login");
		});
		
		const json = await resposta.json();
		
		if (resposta.status == StatusHttp.OK) {
			meusProjetos = [...json.dados];
			totalProjetos = meusProjetos.length;
		} else if (resposta.status == StatusHttp.HTTP_NOT_FOUND) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Ação cancelada!',
				conteudo: 'Nenhum projeto encontrado para que possa realizar a inscrição na Semana de Graduação.'
			});
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: json?.mensagem
			});
			
			replace("/login");
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		return totalProjetos;
	}

	const abrirTermos = () => {
		let conteudoModal = `
			<p>1 – A Semana de Graduação da UERJ é um evento anual para a apresentação e avaliação dos projetos vinculados à Pró-reitoria de Graduação (PR-1): Estágio Interno Complementar, Estágio de Iniciação à Docência, Monitoria, Programa de Articulação Acadêmico-profissional (Prodocência), Programa de Iniciação à Docência (PIBID), Residência Pedagógica (RP), Programa de Educação Tutorial (PET) e projetos finais de curso/monografias. A participação dos projetos ativos será obrigatória para as modalidades Estágio Interno Complementar, Estágio de Iniciação à Docência e Monitoria.</p>
			<p>2 - As inscrições para participação na XXI Semana de Graduação da UERJ nas modalidades acima descritas serão realizadas pelo coordenador/ orientador do projeto/ monografia por meio do resumo do projeto e link de apresentação de trabalho.</p>
			<p>3 – O coordenador/ orientador do projeto/ monografia, mediante o aceite destes termos, concede à <strong>Pró-reitoria de Graduação (PR-1) da Universidade do Estado do Rio de Janeiro (UERJ)</strong>, CNPJ 33.540.014/0001-57, localizada à Rua São Francisco Xavier, 524 – Maracanã, Rio de Janeiro – RJ, os direitos para livre utilização do material submetido para <strong>programas, aulas, palestras e transmissões e publicações por YouTube, website, televisão, webtv, rádio e webrádio desta Universidade</strong> e a qualquer tempo, autorizando consequente e universalmente, sua utilização em toda e qualquer distribuição e exibição da obra audiovisual, por todo e qualquer veículo, processo, ou meio de comunicação e publicidade, existentes ou que sejam criados.</p>
			<p>4 – O coordenador/orientador do projeto/monografia, mediante o aceite destes termos, também se responsabiliza pelo envio da Autorização do uso de imagem e voz de todos os participantes do vídeo preenchida e assinada pelos respectivos para o e-mail semanadegraduacao.cetreina@uerj.br <strong>até ${dataFinalCadastro}</strong>, informando o título do projeto no assunto do e-mail.</p>
			<p>5 - Poderão também participar da XXI Semana de Graduação, os alunos em estágio externo com vínculo ativo. Estes serão os responsáveis por sua inscrição através da submissão de um relato de experiência e link de apresentação.</p>
			<p>Aos alunos de estágio externo também é obrigatória, no momento da inscrição, o envio. Através de upload, da declaração de anuência do supervisor do estágio.</p>
			<p>7 - O aluno de estágio externo, mediante o aceite destes termos, concede à <strong>Pró-reitoria de Graduação (PR-1) da Universidade do Estado do Rio de Janeiro (UERJ)</strong>, CNPJ 33.540.014/0001-57, localizada à Rua São Francisco Xavier, 524 – Maracanã, Rio de Janeiro – RJ, os direitos para livre utilização do material submetido, bem como a livre utilização os direitos sobre sua imagem e som da sua voz neste ato para <strong>programas, aulas, palestras e transmissões e publicações por YouTube, website, televisão, webtv, rádio e webrádio desta Universidade</strong> e a qualquer tempo, autorizando consequente e universalmente, sua utilização em toda e qualquer distribuição e exibição da obra audiovisual, por todo e qualquer veículo, processo, ou meio de comunicação e publicidade, existentes ou que sejam criados.</p>

			<hr>

			<div class="has-text-center">
				<p class="mb-0">Pró-reitoria de Graduação (PR-1)</p>
				<p class="mb-0">Rua São Francisco Xavier, 524, Sala T-031, Bloco F, Maracanã – RJ.</p>
				<p class="mb-0">Telefone: (21) 2334-0682 / 0683</p>
				<p>Email: pr1@uerj.br</p>
			</div>
		`;

		dispatch('routeEvent', {
			tipo: TipoEvento.ABRIR_MODAL,
			titulo: 'TERMOS DE USO DE IMAGEM E VOZ',
			conteudo: conteudoModal,
			larguraMaxima: true
		});
	}
</script>

<TBox 
	titulo="Apresentação Semana de Graduação" 
	subtitulo="Utilize o formulário abaixo para realizar a inscrição" 
	largura="12" 
	deslocamento="0" 
	icone="projeto">

	<div class="notification is-danger is-light">
		Prazo para inscrição de projetos na Semana de Graduação: de <strong>{dataInicialCadastro}</strong> até <strong>{dataFinalCadastro}</strong>.
	</div>
	
	<br>

	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<p><strong>Escolha um de seus projetos para apresentar:</strong></p>
		
		<div class="columns">
			<div class="column">
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={idProjeto} id="seletorProjeto" name="projeto" required>
						<option value="">Selecione um projeto...</option>
						{#each meusProjetos as projeto}
						<option value="{projeto.id}">{projeto.titulo}</option>
						{/each}
					</select>
				</div>
			</div>
		</div>

		<p><strong>Escolha um participante para ser o(a) apresentador(a) titular:</strong></p>

		<div class="columns">
			<div class="column">
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={apresentadorTitular} name="apresentador1" required>
						<option value="">Selecione o(a) apresentador(a) titular...</option>
						{#each apresentadores as apresentador}
						<option value="{apresentador?.nome} ({esconderPartesCPF(apresentador?.cpf)})">{apresentador?.nome} ({esconderPartesCPF(apresentador?.cpf)})</option>
						{/each}
					</select>
				</div>
			</div>
		</div>

		<p><strong>Escolha um participante para ser o(a) apresentador(a) substituto: (OPCIONAL)</strong></p>

		<div class="columns">
			<div class="column">
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={apresentadorSubstituto} name="apresentador2">
						<option value="">Selecione o(a) apresentador(a) substituto...</option>
						{#each apresentadores as apresentador}
						<option value="{apresentador?.nome} ({esconderPartesCPF(apresentador?.cpf)})">{apresentador?.nome} ({esconderPartesCPF(apresentador?.cpf)})</option>
						{/each}
					</select>
				</div>
			</div>
		</div>

		<!-- <div class="notification is-info is-light">
			<p>Os campos "link do vídeo" e "link do arquivo/slide" devem ser preenchidos apenas nos casos de apresentações virtuais. Os campos "Data e hora" e local devem ser preenchidos apenas nos casos de apresentações que serão realizadas nos espaços físicos da universidade. Data e hora e local são apenas para ajudar na logística e organização, <u>ao informar estes dados você <strong>não</strong> está "agendando/alugando/garantindo" o espaço na data e hora informada</u>.</p>
		</div> -->

		<div class="columns">
			<div class="column is-half">
				<small class="has-text-primary">Link do vídeo:</small>
				<div class="field">
					<input 
						bind:value={linkVideo}
						name="link_video" 
						type="text" 
						placeholder="URL vídeo (youtube, vimeo etc)" 
						class="input is-large is-primary">
				</div>
			</div>
			<div class="column is-half">
				<small class="has-text-primary">Link do arquivo/slide ou pdf:</small>
				<div class="field">
					<input 
						bind:value={linkApresentacao}
						name="link_apresentacao" 
						type="text" 
						placeholder="URL documento de apresentação (.PDF, .PPTX etc)" 
						class="input is-large is-primary">
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<div class="control">
					<p>O projeto inclui estudantes dos cursos de graduação EAD?</p>

					<label class="radio">
						<input type="radio" name="cursoEAD" bind:group={cursoEAD} value={true} required>
						Sim
					</label>
					<label class="radio">
						<input type="radio" name="cursoEAD" bind:group={cursoEAD} value={false}>
						Não
					</label>
				</div>
			</div>
		</div>

		<!-- <div class="columns">
			<div class="column is-half">
				<small class="has-text-primary">Data e hora da apresentação</small>
				<div class="field">
					<input 
						bind:value={dataHora}
						name="dataHora" 
						min="2022-10-01T07:00" 
						max="2022-12-01T22:00"
						type="datetime-local" 
						placeholder="Data e hora da apresentação" 
						class="input is-large is-primary">
				</div>
			</div>
			<div class="column is-half">
				<small class="has-text-primary">Local (ex.: bloco, sala, andar etc)</small>
				<div class="field">
					<input 
						bind:value={local}
						name="local" 
						type="text" 
						placeholder="Local (ex.: bloco, sala, andar etc)" 
						class="input is-large is-primary">
				</div>
			</div>
		</div> -->

		<hr>

		<p><strong>Resumo do projeto</strong> (mín. 512 e máx. 3072 caracteres ● Utilizados: {totalCaracteresResumo}):</p>
		<div class="columns">
			<div class="column">
				<div class="field">
					<textarea 
						bind:value={resumo}
						class="textarea is-primary is-size-5" 
						placeholder="Escreva aqui o resumo do projeto para esta apresentação"
						name="resumo"
						rows="10"
						required></textarea>
				</div>
			</div>
		</div>

		<hr>

		<p><strong>Observações</strong> (máx. 512 caracteres ● Utilizados: {totalCaracteresObservacoes}):</p>
		<div class="columns">
			<div class="column">
				<div class="field">
					<textarea 
						bind:value={observacoes}
						class="textarea is-primary is-size-5" 
						placeholder="Utilize este campo para anotações ou observações gerais (não tem relação com o resumo da apresentação, o que for sobre o resumo, utilize apenas o campo acima)"
						name="observacoes"
						rows="3"></textarea>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<span class="has-text-info" style="cursor: pointer;" on:click={ abrirTermos }>Clique aqui para ler os termos de uso de imagem e voz</span>
				<br>

				<label class="checkbox">
					<input type="checkbox" required>
					Você precisa concordar com os <strong>Termos de uso de imagem e voz</strong> para prosseguir com sua inscrição.
				</label>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/" class="button is-black is-medium is-outlined is-fullwidth">Início</a>
				</p>
			</div>
			<div class="column">
				<p class="control">
					<a href="#/painel" class="button is-black is-medium is-outlined is-fullwidth">Painel</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-primary is-medium is-fullwidth">
						Cadastrar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>